import { $axios } from "../config/axios";

export default {
  fetchAllPonds(params) {
    return $axios.get("/ponds", { params });
  },
  fetchActivePonds(params) {
    return $axios.get("/ponds/active/summary", { params });
  },
  fetchInactivePonds(params) {
    return $axios.get("/ponds/inactive/summary", { params });
  },
  fetchPondPerformance(params) {
    return $axios.get("ponds/performance", { params });
  },
  fetchPondWiseDeviceStatus(params) {
    return $axios.get("ponds/device-summary", { params });
  },
};
